export const GREENHOUSE_ORIGIN = /^https?:\/\/([a-z0-9-]+\.)*greenhouse\.(io|dev)(:\d+)?$/i;
